<template>
    <div class="team-Statistics">
        <h4>
            {{ $t('showFraction.TDTJ') }}
        </h4>
        <div class="content-title">
            <div>
                <div class="img-box">
                    <img src="@/assets/image/1.png" />
                </div>
                <div class="text-box">
                    <div class="text-top">
                        <span class="font-title">{{ stData.completeDto ? stData.completeDto.numerator : '0' }}</span>
                        <span class="total-font">/{{ stData.completeDto ? stData.completeDto.denominator : '0' }}</span>
                    </div>
                    <span class="font-status">
                        {{ $t('showFraction.WCDDW') }}
                    </span>
                </div>
            </div>
            <div>
                <div class="img-box">
                    <img src="@/assets/image/2.png" />
                </div>
                <div class="text-box">
                    <div class="text-top">
                        <span class="font-title">{{ stData.absentDto ? stData.absentDto.numerator : '0' }}</span>
                        <span class="total-font">/{{ stData.absentDto ? stData.absentDto.denominator : '0' }}</span>
                    </div>
                    <span class="font-status">
                        {{ $t('showFraction.QQDDW') }}
                    </span>
                </div>
            </div>
            <div>
                <div class="img-box">
                    <img src="@/assets/image/3.png" />
                </div>
                <div class="text-box">
                    <div class="text-top">
                        <span class="font-title">{{ stData.maxScore | toFixed2 }}</span>
                    </div>
                    <span class="font-status">
                        {{ $t('showFraction.ZGF') }}
                    </span>
                </div>
            </div>
            <div>
                <div class="img-box">
                    <img src="@/assets/image/4.png" />
                </div>
                <div class="text-box">
                    <div class="text-top">
                        <span class="font-title">{{ stData.avgMaxScore | toFixed2 }}</span>
                    </div>
                    <span class="font-status">
                        {{ $t('showFraction.PJZGF') }}
                    </span>
                </div>
            </div>
            <div>
                <div class="img-box">
                    <img src="@/assets/image/5.png" />
                </div>
                <div class="text-box">
                    <div class="text-top">
                        <span class="font-title">{{ stData.goodRate | toFixed2 }}</span>
                        <span>%</span>
                    </div>
                    <span class="font-status">
                        {{ $t('showFraction.YXL') }}
                    </span>
                </div>
            </div>
            <div>
                <div class="img-box">
                    <img src="@/assets/image/6.png" />
                </div>
                <div class="text-box">
                    <div class="text-top">
                        <span class="font-title">{{ stData.passRate | toFixed2 }}</span>
                        <span>%</span>
                    </div>
                    <span class="font-status">
                        {{ $t('showFraction.JGL') }}
                    </span>

                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'teamStatistics',
    props: {
        stData: Object
    },
    filters: {
        toFixed2(val) {
            if (!isNaN(Number(val))) {
                return Number(val).toFixed(2) == 0.00 ? 0 : Number(val).toFixed(2)
            } else {
                return 0
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.team-Statistics {
    h4 {
        font-size: 16px;
        font-family: Hiragino Sans GB;
        font-weight: normal;
        line-height: 6px;
        color: #0D141E;
        letter-spacing: 2px;
        margin: 16px 0 24px 0;
    }

    .content-title {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #BCBCC2;
        padding-bottom: 24px;

        .img-box {
            width: 64px;
            height: 64px;
            opacity: 0.8;

            img {
                width: 100%;
            }
        }

        >div {
            display: flex;
            margin-right: 24px;
            flex: 1;
            margin-bottom: 0px;

            .text-box {
                margin: -8px 0 0 8px;

                .font-status,
                .font-title,
                .total-font {
                    font-family: Hiragino Sans GB;
                    font-weight: normal;
                }

                .font-title {
                    font-size: 40px;
                    color: #5397F7;
                }

                .total-font {
                    font-size: 16px;
                    margin-left: 5px;
                    color: #5D646E;
                }

                .font-status {
                    font-size: 13px;
                    color: #5D646E;
                    margin-left: 6px;
                }
            }
        }
    }
}
</style>